import { useEffect, useState } from 'react';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import GridProvider from './components/GridProvider';
import Inputs from './components/Inputs';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import FilterDelova from './components/FilterDelova';
import noImage from './Image/noImage.png';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { isFormValid } from './validation/isFormValid';
import UvozExcelDialog from './components/UvozExcelDialog';

const INITIAL_VALUES = {
  id: 0,
  naziv: '',
  opis: '',
  partNumber: '',
  idMasine: null,
  nazivMasine: '',
  nabavnaCena: '',
  marza: null,
  marzaCount: '',
  prodajnaCena: '',
  favorit: false,
  akcija: false,
  prikazNaShopu: true,
  nazivKategorije: '',
};

const UnosDelova = ({ save, handleSave, novi, handleNovi }) => {
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [listaDelova, setListaDelova] = useState([]);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [slika, setSlika] = useState([]);
  const { t, i18n } = useTranslation();
  const [searchText, setSearchText] = useState('');
  const [openSlikaPopUp, setOpenSlikaPopUp] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [kategorijaDelova, setKategorijaDelova] = useState([]);
  const [openUvoz, setOpenUvoz] = useState(false);

  const vratiMasine = () => {
    sendRequest({ url: urls.VARATI_MASINE });
  };
  const vratiDelove = async () => {
    const config = {
      method: 'POST',
      url: urls.VARATI_DELOVE,
      data: {
        uslovPretrage: searchText,
      },
    };
    const result = await getData(config);
    if (result) {
      setListaDelova(result);
    }
  };
  const vratiKategorijuDelova = async () => {
    const config = {
      method: 'GET',
      url: urls.VRATI_KATEGORIJU_DELOVA,
    };
    const result = await getData(config);
    if (result) {
      setKategorijaDelova(result);
    }
  };
  useEffect(() => {
    vratiMasine();
    vratiDelove();
    vratiKategorijuDelova();
  }, []);
  useEffect(() => {
    if (novi) {
      handleNovi(false);
      setFormValues(INITIAL_VALUES);
      setOpenPopUp(true);
    }
  }, [novi]);
  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValues({ ...INITIAL_VALUES, id: id });
  };
  const handleEditData = async (item) => {
    setFormValues(item);
    setOpenPopUp(true);
  };
  const opetPicture = async (item) => {
    const config = {
      method: 'POST',
      url: urls.GET_SLIKE_ZA_DEO,
      data: { id: item.id },
    };
    const response = await getData(config);

    if (response) {
      console.log('slika', response);
      if (!response.includes('Nema dokumenta')) {
        setPreviewImage(`data:image/jpeg;base64,${response}`);
      } else {
        setPreviewImage(noImage);
      }
    }
    setOpenSlikaPopUp(true);
  };
  const handleSlika = (file) => {
    setSlika(file);
    if (file.length > 0) {
      setFormValues((curr) => {
        return { ...curr, slikaB64: URL.createObjectURL(file[0]) };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, slikaB64: '' };
      });
    }
  };
  const base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };
  const base64ToFile = (base64, filename, contentType) => {
    const blob = base64ToBlob(base64, contentType);
    const file = new File([blob], filename, { type: contentType });
    return file;
  };
  const vratiSlikuDela = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_SLIKE_ZA_DEO,
      data: { id: formValues.id },
    };
    const response = await getData(config);
    if (response) {
      if (!response.includes('Nema')) {
        // const file = base64ToFile(response, 'png.png', 'image/png');
        setFormValues((curr) => {
          return { ...curr, slikaB64: response };
        });
        const file = base64ToFile(response, formValues.name, formValues.type);
        const list = [file];
        setSlika(list);
      }
    }
  };
  useEffect(() => {
    if (formValues.id > 0) {
      vratiSlikuDela();
    }
  }, [formValues.id]);
  const closePopUp = () => {
    setOpenPopUp(false);
    setFormValues(INITIAL_VALUES);
    setSlika([]);
  };
  const handleSaveDeo = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const fd = new FormData();
    fd.append('id', formValues.id);
    fd.append('naziv', formValues.naziv);
    fd.append('opis', formValues.opis);
    fd.append('partNumber', formValues.partNumber);
    fd.append('IdKorProm', +localStorage.idKorisnika);
    fd.append('nabavnaCena', +formValues.nabavnaCena);
    if (formValues.marza) {
      fd.append('marza', +formValues.marza);
    }
    fd.append('prodajnaCena', +formValues.prodajnaCena);

    if (formValues.idKategorijeDela) {
      fd.append('idKategorijeDela', formValues.idKategorijeDela);
    }

    fd.append('favorit', formValues.favorit || false);
    fd.append('akcija', formValues.akcija || false);
    fd.append('prikazNaShopu', formValues.prikazNaShopu || false);

    if (formValues.idMasine) {
      fd.append('idMasine', formValues.idMasine ? +formValues.idMasine : null);
    }
    for (let i = 0; i < slika.length; i += 1) {
      fd.append('Slika', slika[0]);
    }

    const config = {
      method: 'POST',
      url: formValues.id === 0 ? urls.INSERT_DELOVI : urls.UPDATE_DELOVI,
      data: fd,
    };
    const result = await getData(config);
    if (result?.id > 0) {
      closePopUp();
      vratiDelove();
      toast.success(t('dataAddedSuccessfully'));
      setFormValues(INITIAL_VALUES);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const filterDelova = () => {
    vratiDelove();
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DELOVI,
      data: {
        id: formValues.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiDelove();
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  return (
    <div>
      <FilterDelova
        searchText={searchText}
        setSearchText={setSearchText}
        filterDelova={filterDelova}
        otvoriUvoz={() => setOpenUvoz(true)}
      />
      <UvozExcelDialog
        open={openUvoz}
        onClose={() => setOpenUvoz(false)}
        masine={data}
        kategorije={kategorijaDelova}
        onUvezeno={vratiDelove}
      />
      <GridProvider
        data={listaDelova}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        opetPicture={opetPicture}
        loading={isLoading}
      />
      <MuiDialog
        maxWidth="md"
        open={openPopUp}
        title="Details"
        content={
          <Inputs
            formValues={formValues}
            setFormValues={setFormValues}
            handleSlika={handleSlika}
            slika={slika}
            listaMasina={data}
            kategorijaDelova={kategorijaDelova}
          />
        }
        handleClose={() => closePopUp()}
        handleConfirm={handleSaveDeo}
        textConfirm="SAVE"
        deniedText="CANCEL"
      />
      <MuiDialog
        maxWidth="md"
        open={openSlikaPopUp}
        title="Picture preview"
        content={
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: '1', textAlign: 'center' }}>
                <img
                  style={{
                    maxWidth: '800px',
                    objectFit: 'contain',
                    height: 'auto',
                  }}
                  alt="noImage"
                  src={previewImage}
                />
              </div>
            </div>
          </div>
        }
        handleClose={() => setOpenSlikaPopUp(false)}
        deniedText="CLOSE"
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default UnosDelova;
